export default __webpack_public_path__ + "static/media/patientIcon.c4c7169a.svg";